import React from 'react';
import Container from '@mui/material/Container';
import { useParams } from 'react-router-dom';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';


function NewDataResult() {

  const { obj, id, msg, msg2 } = useParams();

  // if(sessionStorage.getItem("Pdsk21D34Rl98") == 'false') {
  //   window.location.href = '/Dashboard';
  // }

  let objectWithText = "";
  if(obj == "Case" && msg == "Created") {
    objectWithText = "New case";
  } else {
    objectWithText = obj;
  }

  let dataLink = "";
  let fullDataLink = "";

  if(obj == "Case" && msg == "Created") {
    dataLink = "CaseDetail";
    fullDataLink = "Cases";
  } else if(obj == "Case" && msg == "Updated") {
    dataLink = "CaseDetail";
    fullDataLink = "Cases";
  } else if(obj == "Lead" && msg == "Updated") {
    dataLink = "LeadDetail";
    fullDataLink = "Leads";
  } else if(obj == "Contact" && msg == "Updated") {
    dataLink = "ContactDetail";
    fullDataLink = "Contacts";
  } else if(obj == "Opportunity" && msg == "Updated") {
    dataLink = "OpportunityDetail";
    fullDataLink = "Opportunities";
  }


  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Backdrop
              sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={true}
              onClick={() => {
                return;
              }}
            >
            <Box
            sx={{
              display: 'flex',
              position: 'absolute',
              top: "40%",
              zIndex: 2,
              flexWrap: 'wrap',
              '& > :not(style)': {
                m: 1,
                width: '100%',
                height: '125px',
                padding: "10px"
              },
            }}
             >
            <Paper elevation={1} >
                <p>{objectWithText} <span style={{ color: "#1976D2" }}>{(obj == "Case" && msg == "Created") ? "" : ""}{(obj == "Case" && msg == "Updated") ? msg2 : ""}{(obj == "Lead" && msg == "Updated") ? msg2 : ""}{(obj == "Opportunity" && msg == "Updated") ? msg2 : ""}{(obj == "Contact" && msg == "Updated") ? msg2 : ""}</span> has been {msg}!</p>
                <Grid container rowSpacing={1} justifyContent="center" columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                
                  { dataLink != "ContactDetail" ? <><Grid item><a href={`/${dataLink}/${id}`}>
                        <Button
                        type="submit"
                        variant="contained"
                        sx={{ mt: 0.5, mb: 0.5 }}
                        >
                        View
                        </Button>
                        </a>
                        </Grid>
                        <Grid item>
                        <a href={`/${fullDataLink}`}>
                        <Button
                        type="submit"
                        variant="outlined"
                        sx={{ mt: 0.5, mb: 0.5 }}
                        >
                        Cancel
                        </Button>
                        </a></Grid></> : <a href={`/Contacts`}>
                        <Button
                        type="submit"
                        variant="contained"
                        sx={{ mt: 0.5, mb: 0.5, ml: 0 }}
                        >
                        Back
                        </Button>
                        </a> }
                        
                </Grid>
                </Paper>
                </Box>
  </Backdrop> 
    </Container>
  )
}

export default NewDataResult;